import { escapeHtml } from './html-utils.js';

function schemaProperties(schema) {
  if (!schema?.properties || typeof schema.properties !== 'object') {
    return [];
  }
  return Object.entries(schema.properties);
}

function fieldRowsFromConfigFields(configFields) {
  return (configFields || [])
    .filter((row) => row?.key?.trim())
    .map((row) => [row.key.trim(), {
      title: row.title?.trim() || row.key.trim(),
      description: row.description?.trim() || '',
      secret: Boolean(row.secret),
      format: row.markdown ? 'markdown' : undefined
    }]);
}

/**
 * @param {object|null} schema JSON Schema subset
 * @param {Array} [configFields] editor field-builder rows (used when schema not saved yet)
 */
export function getPreviewConfigFieldEntries(schema, configFields) {
  const fromSchema = schemaProperties(schema);
  if (fromSchema.length) return fromSchema;
  return fieldRowsFromConfigFields(configFields);
}

export function renderPreviewConfigForm(schema, contextKey, values = {}, configFields = null) {
  const entries = getPreviewConfigFieldEntries(schema, configFields);
  if (!entries.length) {
    return '';
  }

  const fields = entries.map(([key, def]) => {
    const title = def.title || key;
    const isSecret = def.secret === true;
    const isMarkdown = def.format === 'markdown';
    const val = values[key] !== null && values[key] !== undefined ? String(values[key]) : '';
    const fieldId = `widget-preview-cfg-${contextKey}-${key}`;
    const autocomplete = isSecret ? 'new-password' : 'off';

    if (isMarkdown && !isSecret) {
      return `
        <div class="form-group widget-preview-config-field">
          <label class="form-label" for="${escapeHtml(fieldId)}">${escapeHtml(title)}</label>
          <textarea
            id="${escapeHtml(fieldId)}"
            class="form-control"
            rows="4"
            autocomplete="${autocomplete}"
            data-preview-config-field="${escapeHtml(key)}"
          >${escapeHtml(val)}</textarea>
          ${def.description ? `<p class="form-text">${escapeHtml(def.description)}</p>` : ''}
        </div>
      `;
    }

    const inputType = isSecret ? 'password' : 'text';
    return `
      <div class="form-group widget-preview-config-field">
        <label class="form-label" for="${escapeHtml(fieldId)}">${escapeHtml(title)}</label>
        <input
          id="${escapeHtml(fieldId)}"
          class="form-control"
          type="${inputType}"
          autocomplete="${autocomplete}"
          data-preview-config-field="${escapeHtml(key)}"
          value="${escapeHtml(val)}"
        />
        ${def.description ? `<p class="form-text">${escapeHtml(def.description)}</p>` : ''}
      </div>
    `;
  }).join('');

  return `
    <div class="widget-preview-config" data-preview-config="${escapeHtml(contextKey)}">
      <h4 class="widget-preview-config-title">Preview settings</h4>
      <p class="form-text">Fill these in to test <code>fot.getConfig()</code> — the same fields profile owners set when adding your widget.</p>
      ${fields}
    </div>
  `;
}

export function readPreviewConfigFromDom(root, contextKey) {
  const section = root?.querySelector?.(`[data-preview-config="${contextKey}"]`);
  if (!section) return {};

  const config = {};
  section.querySelectorAll('[data-preview-config-field]').forEach((el) => {
    const key = el.dataset.previewConfigField;
    if (!key) return;
    config[key] = el.value ?? '';
  });
  return config;
}
